// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Overview-module--bx--text-truncate--end--PNEyE";
export var bxTextTruncateFront = "Overview-module--bx--text-truncate--front--Y5v6Y";
export var card = "Overview-module--card--pqGel";
export var legionCard = "Overview-module--legion-card--9sR2s";
export var legionCard__media = "Overview-module--legion-card__media--cXT9t";
export var overviewCardPadding = "Overview-module--overview-card-padding--QnaWK";